import React from "react";

export const Resume: React.FC = () => {
    return (
        <div>
            <h1>Resume</h1>
            <div id="content_container">
                <h3>Skills Summary</h3>
                <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit.</p>
                <h3>Employment History</h3>
                <p><span className="style_bold">Job History 1</span><br />
                    City, ST<br />
                    Job description</p>
                <h3>Education</h3>
                <p><span className="style_bold">School name</span><br />
                    City, ST<br />
                    Subjects studied</p>
                <h3>Proficiencies</h3>
                <p>Web Design</p>
                <h3>Professional Affiliations</h3>
                <p>Affiliation</p>
                <p>References available upon request.</p>
            </div>
        </div>);
};

export default Resume;